import type { InternalRefetchQueriesInclude } from '@apollo/client';
import * as yup from 'yup';
import { ProductsSettingsType } from '../../../../../__generated__/graphql';
import { UPDATE_PRODUCT_SETTINGS_NOTES } from '../../../../../api/mutations/settings';
import { useQuotationItemInputHandler } from '../../../../../helpers/customHooks';

interface Props {
  productSettings: ProductsSettingsType;
  refetchQueries: InternalRefetchQueriesInclude,
}

interface FormValues {
  productSettings: ID,
  notes: string,
}

export default function NotesInput(props: Props) {
  const { productSettings, refetchQueries } = props;
  const fieldName = 'notes';

  const validationSchema = yup.object({
    [fieldName]: yup.string(),
  });

  const initialValues: FormValues = {
    notes: productSettings.notes as string,
    productSettings: productSettings.id as ID,
  };

  const { handleChange, values, handleBlur } = useQuotationItemInputHandler({
    mutation: UPDATE_PRODUCT_SETTINGS_NOTES,
    fieldName,
    validationSchema,
    initialValues,
    refetchQueries,
  });

  return (
    <textarea
      name={fieldName}
      value={values[fieldName]}
      onChange={handleChange}
      className='resize-none overflow-ellipsis w-full h-full p-0 text-sm flex items-start border-none ring-0 outline-none bg-transparent shadow-none drop-shadow-none focus:border-none focus:ring-0 focus:outline-none'
      onBlur={() => handleBlur()}
      rows={5}
    />
  );
}
